module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.redefine.js
// module id = 67
// module chunks = 0